<template>
  <div class="mt-6">
    <jade-box>
      <div class="mb-2">
        <JadeGroupHeader>
          {{ $t('service-orders') }}
        </JadeGroupHeader>
      </div>
      <div
        v-if="loading"
        class="eu-pa_6 eu-align_center"
        data-testid="show-loading"
      >
        <emd-loader type="_invert" />
      </div>

      <div v-else>
        <empty-list
          v-if="showEmptyList"
          entity="physical-world-orders"
          svg="pos"
          data-testid="show-empty"
        />

        <empty-list-filter
          v-else-if="showEmptyListFilter"
          entity="pos"
        />

        <div v-else>
          <service-orders-list-item
            v-for="(item, index) in items"
            :key="item.id"
            :source="item"
            :index="index"
          />
          <div class="p-5">
            <jade-pagination
              :disabledPrevious="pagination.current_page === 1"
              :disabledNext="pagination.current_page === pagination.total_page"
              @onPrevious="() => $emit('onPrevious')"
              @onNext="() => $emit('onNext')"
            >
              <jade-text>
                {{ pagination.current_page }} de {{ pagination.total_page }}
              </jade-text>
            </jade-pagination>
          </div>
        </div>
      </div>
    </jade-box>
  </div>
</template>

<script>
import { EmdLoader } from 'emerald-vue/src/components'

import { JadeGroupHeader, JadeBox, JadePagination, JadeText } from '@jade'

export default {
  name: 'ServiceOrdersList',
  components: {
    JadeGroupHeader,
    JadeBox,
    JadePagination,
    JadeText,
    EmdLoader,
    EmptyList: () => import('@/components/project/globals/EmptyList.vue'),
    EmptyListFilter: () =>
      import('@/components/project/globals/EmptyListFilter.vue'),
    ServiceOrdersListItem: () => import('./ServiceOrdersListItem.vue')
  },
  props: {
    items: Array,
    loading: Boolean,
    pagination: Object
  },
  computed: {
    isEmptyList () {
      return !this.loading && this.items?.length === 0
    },
    showEmptyList () {
      return this.isEmptyList && Object.entries(this.$route.query).length <= 2
    },
    showEmptyListFilter () {
      return this.isEmptyList && Object.entries(this.$route.query).length > 2
    }
  }
}
</script>

<i18n src="./service-orders-filters.locale.json"></i18n>
